var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-field"},[(_vm.label)?_c('div',{staticClass:"mb-2"},[_c('form-label',[_vm._v(" "+_vm._s(_vm.label)+" ")])],1):_vm._e(),_vm._t("field"),_vm._t("validationMessage")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }